import React from 'react';

function SpecsCard({ specs }) {
  // Flatten the specs object into an array for display
  const specsArray = [];

  Object.values(specs).forEach(category => {
    Object.values(category).forEach(spec => {
      specsArray.push({
        label: spec.label,
        value: `${spec.value}${spec.unit ? ` ${spec.unit}` : ''}`
      });
    });
  });

  // Take first 6 specs for the grid
  const displaySpecs = specsArray.slice(0, 6);

  return (
    <div className="specs-card">
      <h3>Aircraft Specifications</h3>
      <div className="specs-grid">
        {displaySpecs.map((spec, index) => (
          <div className="spec-item" key={index}>
            <span className="spec-label">{spec.label}</span>
            <span className="spec-value">{spec.value}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default SpecsCard;
